// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2RFPO","productName":"Table_productName__Ap6Y6"};